import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { DatiqTemplateMdService } from './services';

@Directive({
    selector: '[datiqTemplateMd]',
})
export class DatiqTemplateMdDirective implements OnChanges {
    @Input()
    datiqTemplateMd: string;

    constructor(
        private _el: ElementRef,
        private _service: DatiqTemplateMdService,
    ) {}

    ngOnChanges(): void {
        this._el.nativeElement.innerHTML = this._service.render(
            this.datiqTemplateMd ?? '',
        );
    }
}
